import React from "react";
import { Document, Page, View, Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
    color: "#000000",
    backgroundColor: "#ffffff",
  },
  headerContainer: {
    alignItems: "center",
    marginBottom: 15,
    lineHeight: 1.3,
  },
  topTitle: {
    fontSize: 12,
    fontWeight: "bold",
    textDecoration: "underline",
    marginBottom: 2,
    color: "#b91c1c",
  },
  companyName: {
    fontSize: 16,
    fontWeight: "bold",
  },
  companyAddress: {
    fontSize: 9,
    textAlign: "center",
    maxWidth: 500,
  },
  boldText: {
    fontWeight: "bold",
  },
  metaRowContainer: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000000",
    marginBottom: 15,
  },
  metaHalfCell: {
    width: "50%",
    padding: 6,
    flexDirection: "row",
  },
  metaHalfCellRight: {
    width: "50%",
    padding: 6,
    flexDirection: "row",
    borderLeftWidth: 1,
    borderLeftColor: "#000000",
  },
  detailBox: {
    borderWidth: 1,
    borderColor: "#000000",
    padding: 15,
    marginBottom: 15,
  },
  detailLine: {
    marginBottom: 8,
    fontSize: 11,
  },
  amountBox: {
    borderWidth: 1,
    borderColor: "#b91c1c",
    padding: 12,
    marginBottom: 20,
    backgroundColor: "#fef2f2",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  amountLabel: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#b91c1c",
  },
  amountValue: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#b91c1c",
  },
  signBlock: {
    marginTop: 40,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  signBox: {
    width: 180,
    textAlign: "center",
    borderTopWidth: 1,
    borderTopColor: "#000000",
    paddingTop: 5,
  },
  disclaimer: {
    fontSize: 7,
    color: "#555555",
    marginTop: 30,
    textAlign: "center",
  }
});

// props: { creditNote, customer: { name, phone, address } }
export default function CreditNotePDF({ creditNote = {}, customer = {} }) {
  const dateStr = creditNote.created_at
    ? new Date(creditNote.created_at).toLocaleDateString("en-IN")
    : new Date().toLocaleDateString("en-IN");

  return (
    <Document>
      <Page size="A5" style={styles.page}>

        <View style={styles.headerContainer}>
          <Text style={styles.topTitle}>CREDIT NOTE</Text>
          <Text style={styles.companyName}>A.K. CERAMIC WORLD</Text>
          <Text style={styles.companyAddress}>
            70, Palayamkottai Taluk, V.G Panneer Das Town Bye Pass Road, Reddiyarpatti, TIRUNELVELI - 7
          </Text>
          <Text style={styles.boldText}>GSTIN : 33ACDFA2032P1ZL</Text>
        </View>

        <View style={styles.metaRowContainer}>
          <View style={styles.metaHalfCell}>
            <Text style={styles.boldText}>Credit Note No: </Text>
            <Text>{creditNote.credit_note_no || "—"}</Text>
          </View>
          <View style={styles.metaHalfCellRight}>
            <Text style={styles.boldText}>Date: </Text>
            <Text>{dateStr}</Text>
          </View>
        </View>

        <View style={styles.detailBox}>
          <Text style={styles.detailLine}>
            <Text style={styles.boldText}>Issued to: </Text>{customer.name || "—"}
          </Text>
          <Text style={styles.detailLine}>
            <Text style={styles.boldText}>Phone: </Text>{customer.phone || "—"}
          </Text>
          {customer.address && (
            <Text style={styles.detailLine}>
              <Text style={styles.boldText}>Address: </Text>{customer.address}
            </Text>
          )}
          {creditNote.invoice_id && (
            <Text style={styles.detailLine}>
              <Text style={styles.boldText}>Against Invoice: </Text>#{creditNote.invoice_id}
            </Text>
          )}
          <Text style={styles.detailLine}>
            <Text style={styles.boldText}>Reason: </Text>{creditNote.reason || "—"}
          </Text>
        </View>

        <View style={styles.amountBox}>
          <Text style={styles.amountLabel}>Credit Amount</Text>
          <Text style={styles.amountValue}>₹{Number(creditNote.amount || 0).toLocaleString("en-IN")}</Text>
        </View>

        <View style={styles.signBlock}>
          <View style={styles.signBox}>
            <Text style={styles.boldText}>Authorised Signatory</Text>
          </View>
        </View>

        <Text style={styles.disclaimer}>This is a computer generated credit note. This amount has been deducted from the customer's outstanding balance.</Text>

      </Page>
    </Document>
  );
}
